import Grid from '@material-ui/core/Grid';
import OaLabel from '@orientaction/commons/OaLabel';
import { forwardRef } from 'react';
import LeftImage from './LeftImage';
import TitlePart from './TitlePart';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  imageSection: {
    display: 'flex',
    gap: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  titleSection: {
    marginBottom: theme.spacing(2),
  }
}));

const TestMainInfo = forwardRef((_, ref) => {
  const { imageRef, titleRef }: any = ref;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.titleSection}>
        <TitlePart ref={titleRef} />
      </div>
      <div className={classes.imageSection}>
        <div className={classes.imageContainer}>
          <OaLabel>Image du test</OaLabel>
          <LeftImage ref={imageRef} />
        </div>
        <div className={classes.imageContainer}>
          <OaLabel>Miniature du test</OaLabel>
          <LeftImage ref={imageRef} isThumbnail={true} />
        </div>
      </div>
    </div>
  );
});

export default TestMainInfo;
